import React, { FC } from 'react';
import { ContainerLarge } from '../../components/base/grid';
import Refund from '../../components/myPost/refund/refund';
import pageWrapper from '../../hoc/pageWrapper';
import IMyShipmentsRegistrationViewModel from '../../interfaces/myShipments/myShipmentsRegistration';

interface Props {
	page: IMyShipmentsRegistrationViewModel;
}

const MyShipmentsRefund: FC<Props> = ({ page }) => {
	return (
		<ContainerLarge>
			<Refund page={page} />
		</ContainerLarge>
	);
};

export default pageWrapper(MyShipmentsRefund);
